import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i2 from 'primeng/sidebar';
import { SidebarModule } from 'primeng/sidebar';
import * as i3 from 'primeng/api';

class DrawerComponent {
    constructor() {
        /**
         * `isVisible` - Flag which determines whether to show the drawer or not.
         */
        this.isVisible = false;
        /**
         * `showCloseIcon` - Flag which determines whether to show the close icon on the header of drawer.
         */
        this.showCloseIcon = true;
        /**
         * `styleClass` - Class that will be appended to the class list of drawer.
         */
        this.styleClass = '';
        /**
         * `showBackdrop` - Flag which determines whether to show backdrop on the body.
         */
        this.showBackdrop = true;
        /**
         * `dismissOnBackdropClick` - Flag which determines whether to dismiss the drawer on backdrop click.
         */
        this.dismissOnBackdropClick = true;
        /**
         * `closeOnEscape` - Flag which determines whether to dismiss the on escape key press.
         */
        this.closeOnEscape = true;
        /**
         * `position` - Parameter which decides the placement of the drawer.
         */
        this.position = 'bottom';
        /**
         * `drawerTransition` - Sets the transition of the drawer.
         * Example usage: '150ms cubic-bezier(0, 0, 0.2, 1)'
         */
        this.transitionOptions = '150ms cubic-bezier(0, 0, 0.2, 1)';
        /**
         * `closeHandler` - Event emitted whenever the drawer is closed.
         */
        this.closeHandler = new EventEmitter();
        /**
         * `openHandler` - Event emitted whenever the drawer is opened.
         */
        this.openHandler = new EventEmitter();
    }
}
DrawerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DrawerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DrawerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: DrawerComponent, selector: "pv-drawer", inputs: { isVisible: "isVisible", showCloseIcon: "showCloseIcon", style: "style", styleClass: "styleClass", showBackdrop: "showBackdrop", dismissOnBackdropClick: "dismissOnBackdropClick", closeOnEscape: "closeOnEscape", position: "position", transitionOptions: "transitionOptions", headerTemplate: "headerTemplate", contentTemplate: "contentTemplate", footerTemplate: "footerTemplate", closeIconTemplate: "closeIconTemplate" }, outputs: { closeHandler: "closeHandler", openHandler: "openHandler" }, ngImport: i0, template: "<p-sidebar\n  [(visible)]=\"isVisible\"\n  [position]=\"position\"\n  [style]=\"style\"\n  [styleClass]=\"styleClass\"\n  [showCloseIcon]=\"showCloseIcon\"\n  [modal]=\"showBackdrop\"\n  [dismissible]=\"dismissOnBackdropClick\"\n  [closeOnEscape]=\"closeOnEscape\"\n  [blockScroll]=\"true\"\n  [transitionOptions]=\"transitionOptions\"\n  (onHide)=\"closeHandler.emit(false)\"\n  (onShow)=\"openHandler.emit(true)\">\n  <ng-template *ngIf=\"headerTemplate\" pTemplate=\"header\">\n    <ng-container [ngTemplateOutlet]=\"headerTemplate\"></ng-container>\n  </ng-template>\n\n  <ng-template *ngIf=\"closeIconTemplate\" pTemplate=\"closeicon\">\n    <ng-container [ngTemplateOutlet]=\"closeIconTemplate\"></ng-container>\n  </ng-template>\n\n  <ng-template *ngIf=\"contentTemplate\" pTemplate=\"content\">\n    <ng-container [ngTemplateOutlet]=\"contentTemplate\"></ng-container>\n  </ng-template>\n\n  <ng-template *ngIf=\"footerTemplate\" pTemplate=\"footer\">\n    <ng-container [ngTemplateOutlet]=\"footerTemplate\"></ng-container>\n  </ng-template>\n\n  <ng-content></ng-content>\n</p-sidebar>\n", styles: ["@media screen and (min-width: 962px){:host ::ng-deep .p-sidebar{width:50%!important;height:50%!important;left:50%!important;top:50%!important;transform:translate(-50%,-50%)!important}}:host ::ng-deep .p-sidebar-header:empty,:host ::ng-deep .p-sidebar-content:empty,:host ::ng-deep .p-sidebar-footer:empty{display:none}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2.Sidebar, selector: "p-sidebar", inputs: ["appendTo", "blockScroll", "style", "styleClass", "ariaCloseLabel", "autoZIndex", "baseZIndex", "modal", "dismissible", "showCloseIcon", "closeOnEscape", "transitionOptions", "visible", "position", "fullScreen"], outputs: ["onShow", "onHide", "visibleChange"] }, { kind: "directive", type: i3.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DrawerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pv-drawer', template: "<p-sidebar\n  [(visible)]=\"isVisible\"\n  [position]=\"position\"\n  [style]=\"style\"\n  [styleClass]=\"styleClass\"\n  [showCloseIcon]=\"showCloseIcon\"\n  [modal]=\"showBackdrop\"\n  [dismissible]=\"dismissOnBackdropClick\"\n  [closeOnEscape]=\"closeOnEscape\"\n  [blockScroll]=\"true\"\n  [transitionOptions]=\"transitionOptions\"\n  (onHide)=\"closeHandler.emit(false)\"\n  (onShow)=\"openHandler.emit(true)\">\n  <ng-template *ngIf=\"headerTemplate\" pTemplate=\"header\">\n    <ng-container [ngTemplateOutlet]=\"headerTemplate\"></ng-container>\n  </ng-template>\n\n  <ng-template *ngIf=\"closeIconTemplate\" pTemplate=\"closeicon\">\n    <ng-container [ngTemplateOutlet]=\"closeIconTemplate\"></ng-container>\n  </ng-template>\n\n  <ng-template *ngIf=\"contentTemplate\" pTemplate=\"content\">\n    <ng-container [ngTemplateOutlet]=\"contentTemplate\"></ng-container>\n  </ng-template>\n\n  <ng-template *ngIf=\"footerTemplate\" pTemplate=\"footer\">\n    <ng-container [ngTemplateOutlet]=\"footerTemplate\"></ng-container>\n  </ng-template>\n\n  <ng-content></ng-content>\n</p-sidebar>\n", styles: ["@media screen and (min-width: 962px){:host ::ng-deep .p-sidebar{width:50%!important;height:50%!important;left:50%!important;top:50%!important;transform:translate(-50%,-50%)!important}}:host ::ng-deep .p-sidebar-header:empty,:host ::ng-deep .p-sidebar-content:empty,:host ::ng-deep .p-sidebar-footer:empty{display:none}\n"] }]
        }], propDecorators: { isVisible: [{
                type: Input
            }], showCloseIcon: [{
                type: Input
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], showBackdrop: [{
                type: Input
            }], dismissOnBackdropClick: [{
                type: Input
            }], closeOnEscape: [{
                type: Input
            }], position: [{
                type: Input
            }], transitionOptions: [{
                type: Input
            }], headerTemplate: [{
                type: Input
            }], contentTemplate: [{
                type: Input
            }], footerTemplate: [{
                type: Input
            }], closeIconTemplate: [{
                type: Input
            }], closeHandler: [{
                type: Output
            }], openHandler: [{
                type: Output
            }] } });

class PvDrawerModule {
}
PvDrawerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvDrawerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PvDrawerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PvDrawerModule, declarations: [DrawerComponent], imports: [CommonModule, SidebarModule], exports: [DrawerComponent] });
PvDrawerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvDrawerModule, imports: [CommonModule, SidebarModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvDrawerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DrawerComponent],
                    imports: [CommonModule, SidebarModule],
                    exports: [DrawerComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DrawerComponent, PvDrawerModule };
